module.exports = __webpack_public_path__ + "img/videoplayer.1e88ea1e.png";